import refs from '../helpers/refs'

class CCountryCards {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-country-cards')
    .forEach(el => new CCountryCards(el))
})
